import { render, staticRenderFns } from "./Pathev.vue?vue&type=template&id=766c18b7&scoped=true&lang=pug&"
import script from "./Pathev.vue?vue&type=script&lang=ts&"
export * from "./Pathev.vue?vue&type=script&lang=ts&"
import style0 from "./Pathev.vue?vue&type=style&index=0&id=766c18b7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "766c18b7",
  null
  
)

export default component.exports